import { ColumnLayout } from '@monorepo/shared/componentsV2/Table/types';
import { TruncatedLabel } from '@monorepo/shared/componentsV2/TruncatedLabel';
import { bodySmall } from '@monorepo/shared/styles/text';
import { NullableString } from 'mapistry-shared';
import React from 'react';
import styled, { css } from 'styled-components';

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 6ch;
  max-height: 180px;
  overflow: hidden;
`;

const LabelContainer = styled.div<{ isFieldDescriptionsShown: boolean }>`
  ${({ isFieldDescriptionsShown }) => css`
    flex: 0 0 auto;
    ${isFieldDescriptionsShown
      ? css`
          max-height: 75px;
          overflow: auto;
        `
      : ''}
  `}
`;

const DescriptionContainer = styled.div`
  flex: 1 1 auto;
  max-height: 90px;
  padding-top: 5px;
  overflow-y: auto;
`;

const Spacer = styled.div`
  flex: 0 0 auto;
  height: 0.5rem;
`;

const StyledTruncatedLabel = styled(TruncatedLabel)<{
  $align?: ColumnLayout['align'];
}>`
  float: ${({ $align }) => ($align === 'right' ? 'right' : undefined)};
  width: fit-content;
`;

const StyledFieldDescription = styled.div`
  ${bodySmall}
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export function LogEntryTableHeader({
  label,
  isFieldDescriptionsShown,
  fieldDescription,
}: {
  label: string;
  isFieldDescriptionsShown: boolean;
  fieldDescription: NullableString;
}) {
  return (
    <StyledHeader>
      <LabelContainer isFieldDescriptionsShown={isFieldDescriptionsShown}>
        <StyledTruncatedLabel
          label={label}
          isFullTextShown={isFieldDescriptionsShown}
        />
      </LabelContainer>
      {isFieldDescriptionsShown && fieldDescription && (
        <>
          <DescriptionContainer>
            <StyledFieldDescription>{fieldDescription}</StyledFieldDescription>
          </DescriptionContainer>
          <Spacer />
        </>
      )}
    </StyledHeader>
  );
}
